<template>
  <!-- Add Category -->
  <div class="modal fade" id="add-category">
    <div class="modal-dialog modal-dialog-centered custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>ສ້າງຫ້ອງ</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitAddForm">
                <div class="mb-3">
                  <label class="form-label">ຊື່ຫ້ອງ </label>
                  <input type="text" class="form-control" v-model="newCategory.name" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">ປີ</label>
                  <input type="text" class="form-control" v-model="newCategory.year" required />
                </div>
                <div class="mb-0">
                  <div
                    class="status-toggle modal-status d-flex justify-content-between align-items-center"
                  >
                  </div>
                </div>
                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    ຍົກເລີກ
                  </button>
                  <button type="submit" class="btn btn-submit" :disabled="loading">ສ້າງຫ້ອງ</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Category -->

  <!-- Edit Category -->
  <div class="modal fade" id="edit-category">
    <div class="modal-dialog modal-dialog-centered custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>ແກ້ໄຂ ຫ້ອງ</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitEditForm">
                <div class="mb-3">
                  <label class="form-label">ຊື່ຫ້ອງ</label>
                  <input type="text" class="form-control" v-model="editCategory.name" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">ປີ</label>
                  <input type="text" class="form-control" v-model="editCategory.year" required />
                </div>
                <div class="mb-0">
                  <div
                    class="status-toggle modal-status d-flex justify-content-between align-items-center"
                  >
                  </div>
                </div>
                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    ຍົກເລີກ
                  </button>
                  <button type="submit" class="btn btn-submit" :disabled="loading">ບັນທຶກການປ່ຽນແປງ</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Category -->
</template>
<script>
import classService from '@/services/class.service';

export default {
  props: {
    categoryToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      newCategory: {
        name: '',
        year: '',
        active: true,
        image: 'product1.jpg' // Default image (kept for API compatibility)
      },
      editCategory: {
        id: null,
        name: '',
        active: true,
        image: ''
      },
      loading: false
    };
  },
  methods: {
    // Set the category to edit when the edit modal is opened
    setEditCategory(category) {
      this.editCategory = {
        id: category.id,
        name: category.Category,
        year: category.Year || 1, // Updated to use correct field name 'Year'
        active: true,
        image: 'product1.jpg'
      };
    },
    
    // Submit the form to create a new category
    submitAddForm() {
      if (!this.newCategory.name) {
        this.$swal({
          icon: 'error',
          title: 'ຜິດພາດການກວດສອບ',
          text: 'ຕ້ອງລະບຸຊື່ຫ້ອງ',
          confirmButtonClass: 'btn btn-danger'
        });
        return;
      }

      if (!this.newCategory.year) {
        this.$swal({
          icon: 'error',
          title: 'ຜິດພາດການກວດສອບ',
          text: 'ຕ້ອງລະບຸປີ',
          confirmButtonClass: 'btn btn-danger'
        });
        return;
      }
      
      this.loading = true;
      
      // Prepare data for API
      const categoryData = {
        name: this.newCategory.name,
        year: this.newCategory.year,
        active: this.newCategory.active,
        image: this.newCategory.image
      };
      
      // Emit event to parent component to create category
      this.$emit('create-category', categoryData);
      
      // Close modal and reset form
      this.$nextTick(() => {
        document.querySelector('#add-category .close').click();
        this.resetNewCategoryForm();
        this.loading = false;
      });
    },
    
    // Submit the form to update an existing category
    submitEditForm() {
      if (!this.editCategory.name) {
        this.$swal({
          icon: 'error',
          title: 'ຜິດພາດການກວດສອບ',
          text: 'ຕ້ອງລະບຸຊື່ຫ້ອງ',
          confirmButtonClass: 'btn btn-danger'
        });
        return;
      }

      if (!this.editCategory.year) {
        this.$swal({
          icon: 'error',
          title: 'ຜິດພາດການກວດສອບ',
          text: 'ຕ້ອງລະບຸປີ',
          confirmButtonClass: 'btn btn-danger'
        });
        return;
      }
      
      this.loading = true;
      
      // Prepare data for API
      const categoryData = {
        name: this.editCategory.name,
        year: this.editCategory.year,
        active: this.editCategory.active,
        image: this.editCategory.image
      };
      
      // Emit event to parent component to update category
      this.$emit('update-category', this.editCategory.id, categoryData);
      
      // Close modal
      this.$nextTick(() => {
        document.querySelector('#edit-category .close').click();
        this.loading = false;
      });
    },
    
    // Reset the new category form
    resetNewCategoryForm() {
      this.newCategory = {
        name: '',
        year: '',
        active: true,
        image: 'product1.jpg'
      };
    }
  },
};
</script>
